export interface UpdateCompanyRequest {
  company_name: string;
  company_description?: string;
  company_url?: string;
  company_video?: string;
  company_instagram?: string;
  company_facebook?: string;
  company_wechat?: File | string | null;
  company_linkedin?: string;
}

export interface UpdateCompanyImageRequest {
  file: unknown;
  upload_type: UploadType;
}

export enum UploadType {
  COMPANY_LOGO = 'logo',
  COMPANY_BANNER = 'banner',
  PROFILE_PICTURE = 'profile_picture',
}

export interface UpdateCompanyBrochureRequest {
  file: unknown;
  title: string;
  display_order: number;
}

export interface UpdateCompanyDescriptionRequest {
  companyURL: string;
  companyDesc: string;
}

export interface UpdateProfileRequest {
  attendeeName: string;
  companyName: string;
  position: string;
}
